import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const adsOffersQuery = gql`
  mutation AdsConvertClick($data: AdsConverClickInput) {
    adsConvertClick(data: $data)
  }
`

export const adsOffersKey = getQueryNames(adsOffersQuery)[0]

export default adsOffersQuery
